// 브라우저가 접속한 host(localhost 또는 LAN IP)를 그대로 사용 -> 다른 PC에서 접속해도 자동으로 이 PC의 백엔드를 가리킴.
// (IP를 하드코딩하면 DHCP로 IP가 바뀔 때마다 다시 고쳐야 함)
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || `http://${window.location.hostname}:5000`;